var map = {
	"./ActionsModal/Cambio.vue": 814,
	"./ActionsModal/SaveChanges.vue": 815,
	"./ActionsModal/index.vue": 276,
	"./agrocolor.vue": 2076,
	"./araporcei.vue": 2077,
	"./coplaca/ParcelasActionsMultiple.vue": 1171,
	"./coplaca/index.vue": 2078,
	"./default.vue": 2079,
	"./demo.vue": 2080,
	"./sites.vue": 325,
	"./widgets/auditorias.vue": 816,
	"./widgets/dictamenes.vue": 819,
	"./widgets/pacs.vue": 821,
	"./widgets/revisiones.vue": 818,
	"./widgets/solicitudes.vue": 817,
	"./widgets/toma_muestras.vue": 820
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1783;